import React from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import { useActions } from "../../hooks/actions";
import { BreadcrumbItemSpan, HeaderWrapper } from "./styles";

export const Header: React.FC = () => {
  const { member } = useActions();
  const { t: translate } = useTranslation();
  const history = useHistory<{ tab: string; tabPeople?: string; isView?: boolean }>();
  const { memberId } = useParams<{ memberId?: string }>();

  const renderPageTitle = () => {
    if (memberId) {
      if (history.location?.state?.isView)
        return `${translate("view")} ${member?.fullName ? `'${member?.fullName}'` : ""}`;

      return `${translate("edit")} ${member?.fullName ? `'${member?.fullName}'` : ""}`;
    }

    return translate("createMember");
  };

  return (
    <HeaderWrapper>
      <Breadcrumbs separator={<NavigateNext />} aria-label="breadcrumb">
        <BreadcrumbItemSpan
          data-cy="titleMaintainerHeader"
          color={colors.gray800}
          hasCursorPointer={false}
        >
          {renderPageTitle()}
        </BreadcrumbItemSpan>
      </Breadcrumbs>
    </HeaderWrapper>
  );
};
